var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"l-icon",class:{ 'l-icon--left': _vm.left, 'l-icon--right': _vm.right },style:(_vm.styleObj),attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.svg)}})
}
var staticRenderFns = []

export { render, staticRenderFns }